import {
  ArbitraryData,
  Log,
  LogError,
  LogInfo,
  LogStorage,
  LogWarning,
} from '@servicetitan/log-service';

/**
 * Log.dataDefault() (ambient browser info) is private and can't be extended,
 * so host user/tenant context — needed on every entry, including ones an
 * embedded MFE sends directly through the shared instance — is stamped here
 * instead, by overriding the public info/warning/error methods.
 */
export class ContextualLog extends Log {
  constructor(
    logStorage: LogStorage,
    private readonly getContext: () => ArbitraryData,
  ) {
    super(logStorage);
  }

  override info(entry: LogInfo): void {
    super.info(this.withContext(entry));
  }

  override warning(entry: LogWarning): void {
    super.warning(this.withContext(entry));
  }

  override error(entry: LogError, options?: Parameters<Log['error']>[1]): void {
    super.error(this.withContext(entry), options);
  }

  private withContext<T extends { data?: ArbitraryData }>(entry: T): T {
    return { ...entry, data: { ...this.getContext(), ...entry.data } };
  }
}
